import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

// ES6 classNameNameNameName-style
class Founders extends PreLoginSessionCheck {
  render() {

  	return(
		<section className="mtb product-main founder">
			<div className="container">
				<h2>Founders</h2>
				<div className="row">
					<div className="col-md-6">
						<div className="founder-box b-grn">
							<div className="found-img"><img src="../img/found-1.jpg" alt="Nirmala Sankaran, Co-Founder of Heymath"/></div>
							<div className="found-text">
								<h5>Nirmala Sankaran</h5>	
								<h6>Co-founder</h6>
								<p>
Nimmi is the Chief Evangelist and leads product design, innovation and talent at HeyMath! She graduated from SRCC, completed an MBA from IIM Bangalore and has worked for over 12 years with Citibank.
</p>
							</div>
							<div className="clear"></div>
						</div>
					</div>
					<div className="col-md-6">
						<div className="founder-box b-ylw">
							<div className="found-img"><img src="../img/found-2.jpg" alt="Harsh Rajan, Co-Founder of Heymath"/></div>
							<div className="found-text">
								<h5>Harsh Rajan</h5>	
								<h6>Co-founder</h6>
								<p>Harsh worked for over 12 years in the Emerging Markets Fixed Income Derivatives
businesses at Citigroup and Credit Suisse, and is a Fellow of The Institute of Chartered
Accountants of India.</p>
							</div>
							<div className="clear"></div>
						</div>
					</div>
				</div> 
			</div>
		</section>
  		);
  	}
}

export default Founders; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Founders.js